import { selector } from "./selector";
import { crud } from "../../../app/crud";

function buildTransactionsTable(items, messages) {
    var html = '<table class="table">';
    html += '<thead><tr>';
    html += '<th class="table-header-text">' + messages.prepaid_transaction_operation + '</th>';
    html += '<th class="table-header-text">' + messages.prepaid_transaction_amount + '</th>';
    html += '<th class="table-header-text">' + messages.prepaid_transaction_balance_before + '</th>';
    html += '<th class="table-header-text">' + messages.prepaid_transaction_balance_after + '</th>';
    html += '<th class="table-header-text">' + messages.prepaid_transaction_date + '</th>';
    html += '</tr></thead><tbody>';

    items.forEach(function (item) {
        html += '<tr>';
        html += '<td>' + (item.operation ? item.operation.text : '-') + '</td>';
        html += '<td>' + (item.amount || '-') + ' RSD</td>';
        html += '<td>' + (item.balance_before || '-') + ' RSD</td>';
        html += '<td>' + (item.balance_after || '-') + ' RSD</td>';
        html += '<td>' + (item.formatted_date || '-') + '</td>';
        html += '</tr>';
    });

    html += '</tbody></table>';
    return html;
}

const viewTransactions = function (e) {
    e.preventDefault();

    var serialNumber = $(this).data('serial');
    var $modal = $(selector.modalTransactions);
    var $loader = $(selector.transactionsLoader);
    var $content = $(selector.transactionsContent);
    var $empty = $(selector.transactionsEmpty);
    var $error = $(selector.transactionsError);
    var messages = window.translations.messages;

    $modal.find('.modal-title').text(messages.prepaid_view_transactions + ' - ' + serialNumber);
    $loader.show();
    $content.hide().empty();
    $empty.hide();
    $error.hide();

    $modal.modal('show');

    var url = '/customer/prepaid-balance/transactions/' + serialNumber;

    crud.show(url)
        .done(function (response) {
            $loader.hide();
            if (response.items && response.items.length > 0) {
                $content.html(buildTransactionsTable(response.items, messages)).show();
            } else {
                $empty.show();
            }
        })
        .fail(function () {
            $loader.hide();
            $error.show();
        });
};

export { viewTransactions };
